var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "padding-top": ".98rem" } },
    [
      _c("topbar", { attrs: { text: "测试结果" } }),
      _vm._v(" "),
      _c("div", { staticClass: "mainBox" }, [
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "topBox" }, [
            _c("div", { staticClass: "userBox" }, [
              _c("div", { staticClass: "userImg" }),
              _vm._v(" "),
              _c("div", [
                _c("div", { staticClass: "userName" }, [
                  _vm._v(_vm._s(_vm.scaleResult.nickName))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "time" }, [
                  _vm._v(_vm._s(_vm._f("time")(_vm.scaleResult.createTime)))
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "testTitle" }, [
            _vm._v(_vm._s(_vm.scaleResult.scaleTitle))
          ]),
          _vm._v(" "),
          _vm.scaleResult.scaleInfoResult
            ? _c("div", { staticClass: "level" }, [
                _vm._v(_vm._s(_vm.scaleResult.scaleInfoResult.level))
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.scaleResult.scaleInfoResult
            ? _c("div", {
                staticClass: "content",
                domProps: {
                  innerHTML: _vm._s(_vm.scaleResult.scaleInfoResult.content)
                }
              })
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm.resultType === 1
          ? _c("div", { staticClass: "contentBox" }, [
              _c("div", { staticClass: "r2" }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "synthetical" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _vm._l(_vm.scaleResultRoots.slice(0, 5), function(item) {
                    return _c("li", [
                      _c("span", { staticClass: "symptom" }, [
                        _vm._v(_vm._s(item.symptom))
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(item.resultScore))]),
                      _vm._v(" "),
                      _c("span", { staticClass: "explains" }, [
                        _vm._v(_vm._s(item.explains))
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(
                    _vm.scaleResultRoots.slice(5, _vm.scaleResultRoots.length),
                    function(item) {
                      return _c("li", [
                        _c("span", { staticClass: "symptom" }, [
                          _vm._v(_vm._s(item.symptom))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { width: ".5rem" } }, [
                          _vm._v(_vm._s(item.resultScore))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticStyle: { width: ".5rem" } }, [
                          _vm._v(
                            _vm._s(
                              (item.resultScore / item.questionCount).toFixed(2)
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "checkState",
                            class: { active: item.checkState === "无症状" },
                            staticStyle: { width: "1rem" }
                          },
                          [_vm._v(_vm._s(item.checkState))]
                        )
                      ])
                    }
                  )
                ],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resultType === 1
          ? _c("div", { staticClass: "contentBox" }, [
              _c("div", { staticClass: "r3" }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "explainBox" },
                _vm._l(
                  _vm.scaleResultRoots.slice(5, _vm.scaleResultRoots.length),
                  function(item) {
                    return _c("li", { staticClass: "explainItem" }, [
                      _c("span", [
                        _vm._v("【" + _vm._s(item.symptom) + "】：")
                      ]),
                      _vm._v(
                        "\n                " +
                          _vm._s(item.explains) +
                          "\n              "
                      )
                    ])
                  }
                )
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resultType === 2
          ? _c("div", { staticClass: "contentBox" }, [
              _c("div", { staticClass: "r2" }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "synthetical" },
                [
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._l(_vm.scaleResultRoots, function(item) {
                    return _c("li", [
                      _c("span", { staticClass: "symptom" }, [
                        _vm._v(_vm._s(item.symptom))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticStyle: { width: ".5rem" } }, [
                        _vm._v(_vm._s(item.resultScore))
                      ]),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticStyle: { width: "3rem", "text-align": "right" }
                        },
                        [_vm._v(_vm._s(item.remark))]
                      )
                    ])
                  })
                ],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.resultType === 2
          ? _c("div", { staticClass: "contentBox" }, [
              _c("div", { staticClass: "r3" }),
              _vm._v(" "),
              _c(
                "ul",
                { staticClass: "explainBox" },
                _vm._l(_vm.scaleResultRoots, function(item) {
                  return _c("li", { staticClass: "explainItem" }, [
                    _c("span", [_vm._v("【" + _vm._s(item.symptom) + "】：")]),
                    _vm._v(
                      "\n                " +
                        _vm._s(item.explains) +
                        "\n              "
                    )
                  ])
                })
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticStyle: {
          color: "#606060",
          "border-bottom": "solid 0.02rem #707070"
        }
      },
      [
        _c("span", [_vm._v("综合项")]),
        _vm._v(" "),
        _c("span", [_vm._v("常模（均分±标准差)")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticStyle: {
          color: "#606060",
          "border-bottom": "solid 0.02rem #707070",
          "margin-top": ".8rem"
        }
      },
      [
        _c("span", { staticClass: "symptom" }, [_vm._v("因子项")]),
        _vm._v(" "),
        _c("span", { staticStyle: { width: ".5rem" } }, [_vm._v("得分")]),
        _vm._v(" "),
        _c("span", { staticStyle: { width: ".5rem" } }, [_vm._v("均分")]),
        _vm._v(" "),
        _c("span", { staticStyle: { width: "1rem" } }, [_vm._v("诊断参考")])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "li",
      {
        staticStyle: {
          color: "#606060",
          "border-bottom": "solid 0.02rem #707070",
          "margin-top": ".8rem"
        }
      },
      [
        _c("span", { staticClass: "symptom" }, [_vm._v("因子项")]),
        _vm._v(" "),
        _c("span", { staticStyle: { width: ".5rem" } }, [_vm._v("得分")]),
        _vm._v(" "),
        _c("span", { staticStyle: { width: "3rem", "text-align": "right" } }, [
          _vm._v("诊断参考")
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53173bad", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53173bad","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/result.vue
// module id = null
// module chunks = 